import React, {Component} from 'react'
import { base } from '../../base';
import SideMenu from '../admin/SideMenu';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../../styles/css/AdminMain.css'

class SetUpQuestions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            questionList: [],
            selectedQuestion: {},
            inputs: ['input-0'],
            modal: false
        };
        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    deleteQuestion(e){
      e.preventDefault();
      var array = this.state.questionList;
      var index = array[e.target.value];
      //eslint-disable-next-line
      var result = confirm("Delete Question? ALL DATA ASSOCIATED WITH IT WILL BE LOST");
      if (result) {
        base.remove('questionList/' + index.key, function(err) {
          if(err){
            alert("Something went wrong!")
          }
        })
      }
    }

    componentWillMount() {
        this.ref = base.syncState(`questionList`, {
            context: this,
            state: 'questionList',
            asArray: true,
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.ref);
    }

    handleSubmit(event) {
      event.preventDefault();
      const data = new FormData(event.target);
      var question = data.get('question');
      var answersArray = this.state.inputs;
      var answerValuesArray = [];
      for(var answer in answersArray){
        if(!data.get(answersArray[answer])){
          alert("One or more answers is blank!");
          return
        } else {
          answerValuesArray.push(data.get(answersArray[answer]))
        }
      }
      if(!question){
        alert("No question added");
        return;
      }
      var vm = this;
      base.push('questionList', {
        data: {question: question, answers: answerValuesArray},
        then(err){
          if(!err){
            document.getElementById("create-question-form").reset();
            vm.setState({
              selectedQuestion: {},
            })
          }
        }
      })
    }

    appendInput() {
        var newInput = `input-${this.state.inputs.length}`;
        this.setState({ inputs: this.state.inputs.concat([newInput]) });
    }

    deleteAnswer(e){
      e.preventDefault();
      var array = this.state.inputs;
      var index = e.target.value;
      if(index === "0"){
        alert("Must leave at least one answer!");
        return;
      }
      //eslint-disable-next-line
      var result = confirm("Delete Answer?");
      if (result) {
        array.splice(index, 1);
        this.setState({
          inputs: array,
        })
      }
    }

    toggle() {
      this.setState({
        modal: !this.state.modal,
        selectedQuestion: {},
      });
    }

    render() {
        var questionList = this.state.questionList;
        var selectedQuestion = this.state.selectedQuestion;
        var editQuestionText = "";
        if(Object.keys(selectedQuestion).length === 0){
          selectedQuestion = null;
        } else {
          editQuestionText = selectedQuestion.question;
        }
        return (
          <div className="admin-wrapper">
            <SideMenu/>
            <div className="admin-main-panel">
            <h1>Set Up Questions</h1>
            <div style={{textAlign: "center"}}>
              <Button className="btn btn-default btn-admin btn-create-question" onClick={this.toggle}>New Question <i className="fa fa-plus" aria-hidden="true"></i></Button>
            </div>  
              <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>Add/Edit Question</ModalHeader>
                  <ModalBody>
                    <div className="container-out">
                      <div className="question-box question-form">
                        <form onSubmit={this.handleSubmit} id="create-question-form">
                          <div className="form-group">
                            <label htmlFor="question">Enter Question: </label>
                            <input id="question" name="question" type="text" className="form-control" defaultValue={editQuestionText}/>
                          </div>
                         <div id="dynamicInput">
                             {
                               this.state.inputs.map(function(input,i){
                                return <div className="form-group" key={i}>
                                   <label htmlFor="answer">Enter Answer Option: </label>
                                   <input id={input} name={input} type="text" className="form-control"/>
                                   <button className="btn btn-danger btn-admin btn-delete-option" onClick={this.deleteAnswer.bind(this)} value={i}>DELETE OPTION</button>
                                 </div>
                               }, this)
                             }
                         </div>
                          <button className="btn btn-default btn-admin">Submit</button>
                        </form>
                        <button className="btn btn-default btn-add-answer-option" onClick={ () => this.appendInput() }>
                            ADD ANSWER OPTION
                        </button>
                      </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={this.toggle}>Close</Button>
                  </ModalFooter>
              </Modal>
              <div className="">
                <div className="admin-grid-container">
                {
                  questionList.map(function(item,i){
                    return <div key={i} className="question-box" style={{textAlign: "left"}}>
                        <p><strong>Question:</strong> {item.question}</p>
                        {
                          item.answers.map(function(answer, t) {
                            return <p key={t}><strong>Answer:</strong> {answer}</p>
                          })
                        }
                        <button className="btn btn-default btn-admin" onClick={this.deleteQuestion.bind(this)} value={i}>DELETE</button>
                      </div>
                  }, this)
                }
                </div>
              </div>
            </div>
          </div>
        )
    }
}

export default SetUpQuestions;



// WEBPACK FOOTER //
// ./src/components/admin/SetUpQuestions.js